import { __awaiter, __generator } from "tslib";
import { deprecatedTextAreaAutosizeKey } from './text-area-autosize';
export var createDeprecatedTextAreaAutosizeDriver = function (wrapper) {
    var base = wrapper.$("." + deprecatedTextAreaAutosizeKey);
    return {
        getValue: function () { return base.value(); },
        enterValue: function (value) { return base.enterValue(value); },
        disabled: function () { return __awaiter(void 0, void 0, void 0, function () {
            var dis;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.attr('disabled')];
                    case 1:
                        dis = _a.sent();
                        return [2 /*return*/, !!dis];
                }
            });
        }); },
        readOnly: function () { return __awaiter(void 0, void 0, void 0, function () {
            var val;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, base.attr('readonly')];
                    case 1:
                        val = _a.sent();
                        return [2 /*return*/, !!val];
                }
            });
        }); },
    };
};
//# sourceMappingURL=driver.js.map